import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface PostParamsState {
  page: number;
  limit: number;
  text: string;
  author: string;
  cashtag: string;
  hashtag: string;
  timeRange: string;
  who: string;
  order: "asc" | "desc";
  subtype: string;
  topic: string;
  sortBy: "createdAt" | "likes";
}

const initialState: PostParamsState = {
  page: 1,
  limit: 30,
  text: "",
  author: "",
  cashtag: "",
  hashtag: "",
  timeRange: "24h",
  who: "",
  order: "desc",
  subtype: "",
  topic: "",
  sortBy: "createdAt",
};

export const postParamsSlice = createSlice({
  name: "postParams",
  initialState,
  reducers: {
    setParams: (state, action: PayloadAction<Partial<PostParamsState>>) => {
      Object.assign(state, action.payload);
    },
    resetPage: (state) => {
      state.page = 1;
    },
  },
});

export const { setParams, resetPage } = postParamsSlice.actions;
export default postParamsSlice.reducer;
